import { PageHeader } from '../../components/ui/PageHeader';

type DemPlaceholderPageProps = {
  title: string;
  description: string;
  desktopModule?: string;
};

export function DemPlaceholderPage({ title, description, desktopModule }: DemPlaceholderPageProps) {
  return (
    <>
      <PageHeader title={title} description={description} />

      <div className="card dem-placeholder-card">
        <p className="dem-placeholder-badge">Coming soon</p>
        <p>
          This module will be ported from the desktop <strong>Data Entry Management</strong> app
          {desktopModule ? (
            <>
              {' '}
              (<code>{desktopModule}</code>)
            </>
          ) : null}
          .
        </p>
        <p className="page-lead">
          Scaffold preview — no Supabase changes. Data will connect to{' '}
          <code>data_entry_management</code> when this screen is implemented.
        </p>
      </div>
    </>
  );
}
